import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import AboutTwo from '../../components/about-two'
import CtaOne from '../../components/cta/cta-one'
import Partner from '../../components/partner'
import PricingTwo from '../../components/pricing-two'
import FooterLight from '../../components/footer-light'

import heroImg from '../../assets/images/startup/startup.png'
import { featureData, skillData, teamData } from '../../data/startup'

export default function IndexStartup() {
  return (
    <>
     <Navbar/> 

    <section className="bg-half-170 bg-light d-table w-100">
      <div className="container">
          <div className="row align-items-center mt-5">
              <div className="col-lg-6 col-md-5">
                  <div className="me-lg-5">
                      <img src={heroImg} className="img-fluid rounded" alt=""/>
                  </div>
              </div>

              <div className="col-lg-6 col-md-7 mt-4 pt-2 mt-sm-0 pt-sm-0">
                  <div className="title-heading mt-4">
                      <h1 className="heading mb-3">Startups Project with Leaping Startup</h1>
                      <p className="para-desc text-muted">Start work with <span className="text-primary">Leaping</span>. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <form>
                          <div className="row mt-4">
                              <div className="col-lg-8 col-md-7">
                                  <div className="mb-3">
                                      <input name="email" id="email" type="email" className="form-control" required placeholder="Your email :"/>
                                  </div> 
                              </div>

                              <div className="col-lg-4 col-md-5">
                                  <div className="d-grid">
                                      <input type="submit" id="submit" name="send" className="btn btn-primary" value="Get Started"/>
                                  </div>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
      </div>
    </section>


    <section className="section">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Design Features & Services</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {featureData.map((item,index)=>{
              return(
                <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                    <div className="feature p-3 py-4 rounded">
                        <i className={`mdi mdi-layers-triple-outline text-primary float-start me-3 mt-2 mdi-36px ${item.icon}`}></i>
                        <div className="content d-block overflow-hidden">
                            <h4 className="title">{item.title}</h4>
                            <p className="text-muted mt-2">{item.desc}</p>
                            <Link to="#" className="text-dark">Read More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                        </div>
                    </div>
                </div>
              )
            })}
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <AboutTwo/>
      </div>
    </section>
    <CtaOne/>

    <section className="section">
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Our Team Members</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {teamData.map((item,index)=>{
              return(
                <div className="col-md-6 col-12 mt-4 pt-2" key={index}>
                  <div className="team-list position-relative overflow-hidden shadow rounded">
                      <img src={item.image} className="img-fluid float-start" alt=""/>
                      <div className="content float-end p-4">
                          <h5 className="title mb-0">{item.name}</h5>
                          <small className="text-muted">{item.position}</small>
                          <p className="text-muted mt-3">{item.desc}</p>
                          <ul className="list-unstyled follow social-icon social mb-0">
                            {item.social.map((el,index)=>{
                              return(
                                <li className="list-inline-item m-x-2" key={index}><Link to="#" className="rounded"><i className={el} title="Facebook"></i></Link></li>
                              )
                            })}
                          </ul>
                      </div>
                  </div>                        
                </div>
              )
            })}
          </div>

          <div className="row mt-4">
            {skillData.map((item,index)=>{
              return(
                <div className="col-md-6 mt-4" key={index}>
                    <div className="progress-box">
                        <h6 className="title text-muted">{item.title}</h6>
                        <div className="progress">
                            <div className="progress-bar progress-bar-striped position-relative bg-primary" style={{width:item.progress}}>
                                <div className="progress-value d-block text-muted h6">{item.progress}</div>
                            </div>
                        </div>
                    </div>
                </div>
              )
            })}
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <Partner/>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Our Rates For You</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>
          <PricingTwo/>
      </div>

      <div className="container mt-100 mt-60">
          <div className="bg-dark bg-cta-dark rounded p-md-5 p-4 p-sm-0 shadow">
              <div className="row align-items-center">
                  <div className="col-sm-7">
                      <div className="text-sm-start">
                          <h4 className="text-white title-dark">Ready to start your project ?</h4>
                          <p className="text-white-50 para-desc para-dark mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      </div>
                  </div>

                  <div className="col-sm-5 mt-4 mt-sm-0">
                      <div className="text-sm-end">
                          <Link to="/contact" className="btn btn-primary"><i className="mdi mdi-phone-outline"></i> Contact Now</Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <FooterLight/>
    </>
  )
}
